import { Fragment as _Fragment } from "react/jsx-runtime";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { Tooltip, useMediaQuery, useTheme } from "@chakra-ui/react";
export default function AdaptiveTooltip(props) {
  var _props$breakpoint = props.breakpoint,
      breakpoint = _props$breakpoint === void 0 ? "md" : _props$breakpoint,
      rest = _objectWithoutProperties(props, ["breakpoint"]); // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access


  var minWidth = useTheme().breakpoints[breakpoint];

  var _useMediaQuery = useMediaQuery(["(min-width: ".concat(minWidth, ")")]),
      _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
      shouldShow = _useMediaQuery2[0]; // eslint-disable-next-line react/jsx-no-useless-fragment


  return shouldShow ? /*#__PURE__*/_jsx(Tooltip, _objectSpread({}, rest)) : /*#__PURE__*/_jsx(_Fragment, {
    children: rest.children
  });
}